module.exports = __webpack_public_path__ + "img/ricardo-ortiz-morales.a52f48e7.jpg";